var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_User_Line",
    "data-name": "icons/User/Line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18.333,
    viewBox: "0 0 15 18.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M1.667,7.5V9.167A.833.833,0,1,1,0,9.167V7.5a7.5,7.5,0,0,1,15,0V9.167a.833.833,0,1,1-1.667,0V7.5a5.833,5.833,0,1,0-11.667,0Z",
    transform: "translate(0 8.333)",
    fill: "#777e90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M5,10a5,5,0,1,1,5-5A5.006,5.006,0,0,1,5,10ZM5,1.666A3.333,3.333,0,1,0,8.333,5,3.338,3.338,0,0,0,5,1.666Z",
    transform: "translate(2.5)",
    fill: "#777e90"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu1);
export default __webpack_public_path__ + "static/media/menu1.0f0d9c8aea757c63ebc1e83934d107e4.svg";
export { ForwardRef as ReactComponent };